import { app } from '../../app.module'
/**
 * 全体的処理用サービス
 */
export class CommonService {
  constructor(
    private $rootScope,
    private $mdDialog,
    private RestangularService,
    private $mdToast
  ) {}

  /**
   * SNSでアカウント確認用のURLをセット
   * @param {string} snsType SNSタイプ
   * @param {string} accountId アカウントID
   * @param {string} username アカウント名
   * @return {string} 確認用のURL
   */
  public setAccountUrl(snsType: string, accountId: string, username: string): string {
    let accountUrl = ''

    switch (snsType) {
      case 'facebook':
        accountUrl = 'https://www.facebook.com/' + accountId
        break

      case 'twitter':
        accountUrl = 'https://x.com/' + username
        break

      case 'instagram':
        accountUrl = 'https://www.instagram.com/' + username
        break

      case 'youtube':
        accountUrl = 'https://www.youtube.com/channel/' + accountId
        break

      case 'line':
        accountUrl = 'https://timeline.line.me/user/' + accountId
        break

      case 'tiktok':
        accountUrl = 'https://www.tiktok.com/@' + username
        break
    }

    return accountUrl
  }

  /**
   * SNSで投稿確認用のURLをセット
   * @param {string} snsType SNSタイプ
   * @param {object} post 投稿情報
   * @return {object} 確認用のURL
   */
  public setPostUrl(
    snsType: string,
    accountId: string,
    postId: string,
    linkUrl: string,
    postType: string,
    username: string
  ) {
    let postUrl = ''

    switch (snsType) {
      case 'facebook':
        postUrl = `https://www.facebook.com/${accountId}/posts/${postId}`
        break

      case 'twitter':
        postUrl = `https://x.com/${accountId}/status/${postId}`
        break

      case 'instagram':
        postUrl = linkUrl
        break

      case 'youtube':
        postUrl = `https://www.youtube.com/watch?v=${postId}`
        break

      case 'line':
        postUrl = `https://timeline.line.me/post/${accountId}/${postId}`
        break

      case 'tiktok':
        postUrl = `https://tiktok.com/@${username}/${
          postType === 'carousel' ? 'photo' : 'video'
        }/${postId}`
        break
    }

    return postUrl
  }

  /**
   * アカウント詳細モーダルを開く
   * @param {string} snsType SNSタイプ
   * @param {string} stateView 表示画面(memo or analytics)
   * @param {string} accountId アカウントID
   */
  public showAccountDetailModal(snsType: string, stateView: string, accountId: string): void {
    const modalScope: {
      snsType: string
      stateView: string
      accountId: string
    } = this.$rootScope.$new()

    // SNS種別
    modalScope.snsType = snsType
    // 表示画面
    modalScope.stateView = stateView
    // アカウントID
    modalScope.accountId = accountId

    // モーダルを表示する
    this.$mdDialog.show({
      template: require('../account-detail-modal/account-detail-modal.pug')(),
      scope: modalScope,
      clickOutsideToClose: true,
    })
  }

  public getBrandIdList() {
    this.RestangularService.request('GET', '/brand/getBrandIdList', {
      isPro: this.$rootScope.isPro,
      groupId: this.$rootScope.groupId,
    }).then((result) => {
      this.$rootScope.brandIds = result[0].data
    })
  }

  /**
   * セッションの状態をチェック
   */
  public checkSession() {
    const interval = setInterval(() => {
      const endpoint = '/users/checkSession'
      const params = {}

      this.RestangularService.request('GET', endpoint, params).then((result) => {
        if (result[0].data === false) {
          clearInterval(interval)
          this.$mdToast.show({
            template: `
              <md-toast class="md-error-toast-theme">
                <div class="md-toast-content" style="font-weight: bold;">
                  <div>
                    セッションの接続が切れました。
                    <br>恐れ入りますが、再度ログインしてセッションを有効にしてください。
                  </div>
                  <div>
                    <a href="/login" target="_self"><button class="md-raised md-primary md-button">ログアウト</button></a>
                  </div>
                </div>
              </md-toast>
              `,
            autoWrap: true,
            hideDelay: 0,
            position: 'top right',
          })
        }
      })
    }, 60000)
  }
}

app.service('CommonService', CommonService)
